import React from "react";

function useScreenVisible(callback, offset = 128) {
    const ref = React.useRef(null);
    const [fired, setFired] = React.useState(false);

    React.useLayoutEffect(() => {
        if (fired) return;
        const handleScroll = () => {
            if (!ref.current) return;
            const vtop = (window.scrollY || window.pageYOffset) - offset;
            const vbot = vtop + window.innerHeight - offset;
            const bbox = ref.current.getBoundingClientRect();
            const btop = bbox.y || bbox.top;
            const bbot = btop + bbox.height;
            const topEdgeInView = btop > vtop && btop < vbot;
            const botEdgeInView = bbot > vtop && bbot < vbot;
            if (topEdgeInView || botEdgeInView) {
                callback && callback();
                setFired(true);
            }
        };
        setTimeout(handleScroll, 500);
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("load", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [fired]);

    return ref;
}

export default useScreenVisible;
